<template>
  <div>
    <div
      class="d-flex flex-column justify-center align-center"
      style="background-color: #f4f7f9"
    >
      <p style="color: grey" class="caption">
        Copyright ©{{ new Date().getFullYear() }} Spacepack Inc. All rights
        reserved. <a @click="openPrivacyPolicy"><u>Privacy Policy</u></a> and
        <a @click="openTermsAndConditions"><u>Terms and Conditions</u></a>
      </p>
    </div>
    <TermsAndConditions ref="termsAndConditions"></TermsAndConditions>
    <PrivacyPolicy ref="privacyPolicy"></PrivacyPolicy>
  </div>
</template>

<script>
import TermsAndConditions from './usage/TermsAndConditions.vue'
import PrivacyPolicy from './usage/PrivacyPolicy.vue'

export default {
  components: {
    TermsAndConditions,
    PrivacyPolicy
  },
  methods: {
    openTermsAndConditions() {
      this.$refs.termsAndConditions.open()
    },
    openPrivacyPolicy() {
      this.$refs.privacyPolicy.open()
    }
  }
}
</script>
